import React from 'react';
import { Grid, Box, Tabs, Tab } from '@mui/material';
import { TabPanel } from '../../../common/tabPanel';
import { AddJobCommand, AddProductCommand,  FileData, PanderCountItem } from '../../../api/models/schema';
import ClientPanderTab from './pander/clientPanderTab';
import ClientJobTab from './job/clientJobTab';


function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export interface ClientTabProps {

    panderUploadStatus:PanderCountItem | undefined,
    onRefresh: () => void,
    onSubmitJob: (addJobCommand: AddJobCommand) => void,
    onAddPanderFile: (panderFile:FileData) => void,
    onAddProduct: (addProductCommand: AddProductCommand) => void,
    onDeleteProduct: (productId: number) => void
}

export default function ClientTabs(props: ClientTabProps) {
    const [tabValue, setTabValue] = React.useState(0);



    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    };

    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={tabValue} onChange={handleChangeTabs} aria-label="tabs">
                        <Tab label="JOBS" {...a11yProps(0)} />
                        <Tab label="PANDER FILES" {...a11yProps(1)} />
                    </Tabs>
                </Box>
                <TabPanel value={tabValue} index={0}>
                    <ClientJobTab  onAdd={props.onSubmitJob} onRefresh={props.onRefresh} />
                </TabPanel>
                <TabPanel value={tabValue} index={1}>
                    <ClientPanderTab onAdd={props.onAddPanderFile} panderUploadStatus={props.panderUploadStatus}  />
                </TabPanel>
               
            </Grid>
        </Grid>
    )
};
